import React from "react";

const Copyright = () => {
  return (
    <div className="row">
      <div className="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4">
        <div className="text-center mt-4">
          <p>&nbsp;;&nbsp;</p>
          <a href="/privacy" className="text-white lead footer-privacy">
            Privacy
          </a>
          <br />
          <br />
          <a href="/tnc" className="text-white lead footer-tnc">
            Terms&nbsp;&amp;&nbsp;Conditions
          </a>
        </div>
        <div className="footer-links text-center">
          <a href="https://web.facebook.com/nibebeapp/">
            <i className="zmdi zmdi-facebook"></i>
          </a>
          <a href="https://t.me/nibebebot">
            <i className="zmdi zmdi-comment-alt-text"></i>
          </a>
          <a href="https://www.linkedin.com/company/nibebe/">
            <i className="zmdi zmdi-linkedin"></i>
          </a>
          <a href="https://www.instagram.com/nibebe.app/">
            <i className="zmdi zmdi-instagram"></i>
          </a>
        </div>
        <div className="footer-text text-center">
          <span>All Rights Reserved © nibebe {new Date().getFullYear()}</span>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
